import { useTranslation } from 'react-i18next';
import Button from '../Button';
import Modal from '../Modal/Modal';
import { PropsWithChildren } from 'react';
import Flag from '../CountryLabel/Flag';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  title: string;
  country?: string;
}

export default function NotificationModal({
  isModalOpened,
  closeModal,
  title,
  country,
  children,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpened={isModalOpened}
      close={closeModal}
      title={title}
      name='notification-widget-modal'
    >
      <div className='mx-4 px-4 pb-6 pt-4'>
        <div className='flex items-center gap-x-2 pb-2 '>
          {!!country && <Flag country={country} className='!h-6 !w-6' />}
          <span className='Title--sm font-extrabold'>{t(title)}</span>
        </div>
        {children}
        <div>
          <Button styling='outline' onClick={closeModal}>
            {t('Close')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
